/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { AuthorizationService } from '~app/modules/authorization/services/authorization.service';
import { AuthService } from '~app/modules/authorization/services/authorization-idam.service';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { IAdvancedFormEvent } from '~shared/modules/advanced-form/models/advanced-form.model';
import { AuthorizationFormClassDirective } from '~app/modules/authorization/classes/authorization-form.class';
import { ErrorsUtil } from '~shared/utils/errors.util';
import { TranslateService } from '@ngx-translate/core';
import {
  AUTHORIZATION_NOTIFICATIONS,
  taxIDConflictError,
} from '~app/modules/authorization/constants/authorization.constant';
import { CURRENT_MARKET_LINKS } from '~shared/constants/links.constants';
import { ScrollUtils } from '~shared/utils/scroll.utils';
import { MarketDetectionUtil } from '~shared/utils/market-detection.util';
import { IdamRegisterTrackingService } from '~app/modules/authorization/services/idam-register-tracking.service';
import { isPlatformBrowser } from '@angular/common';
import { combineLatest } from 'rxjs';
import { take, takeUntil, filter } from 'rxjs/operators';
import { HOTJAR_EVENT_LIST } from '~app/modules/authorization/constants/hotjar-event-name-list.constant';
// prettier-ignore
// prettier-ignore
import {
  ConfigureCountryWiseFieldsService
} from '~app/modules/authorization/services/configure-country-wise-fields.service';
// prettier-ignore
import {
  CountryBasedTierTwoConfigService
} from '~app/modules/authorization/services/country-based-tier-two-config.service';
import { CSSHttpError } from '~shared/modules/error-handler/models/css-error.model';
import { BusinessStatus, VatNumberErrors } from '~app/modules/authorization/constants/business-status.constant';
import { PasswordlessService } from '../../services/passwordless.service';
// eslint-disable-next-line max-len
import {
  COUNTRY_WITH_VAT_NUMBER_VALIDATION,
  IS_SAVE_LEGAL_ADDRESS_AS_BILLING_AND_SHIPPING,
} from '~app/modules/authorization/constants/registration-tier-two-constants';
import { CountryCode, NUMBER_1 } from '~shared/constants';
import { HotJarEventsService } from '~app/modules/authorization/services/hot.jar.events.service';
import { TierTwoRegistrationData } from '../../models/credentials.model';
import { AccountRegistrationSuccess } from '../../models/css-api-response.model';
import { VAT_ID_VALIDATION_GA_EVENT_LABELS } from '../../constants/vat-id-check.constant';
import { FF_ENABLE_BRANCH_SELECTION_DESIGN } from '../../constants/branch-selection.contant';
import { CompanyDetailsFromIdService } from '../../services/company-details-from-id.service';
import {
  IEntrepreneurInfoFrance,
  IEntrepreneurInfoNetherlands,
} from '~app/modules/account/modules/account-management/models/user-info.model';

declare const hj;

@Component({
  selector: 'app-add-business-details',
  templateUrl: './add-business-details.component.html',
  styleUrls: ['./add-business-details.component.scss'],
})
export class AddBusinessDetailsComponent extends AuthorizationFormClassDirective {
  public CURRENT_MARKET_LINKS;
  public currentCountry;
  public advancedFormConfig;
  isBusiness = true;
  isFieldDisabled = false;
  branch: IEntrepreneurInfoNetherlands | IEntrepreneurInfoFrance;
  isNewBusinessDetailsDesignEnabled$ = this.activeFeaturesConfigCatService.isFeatureEnabledReadyForCurrentCountry$(
    FF_ENABLE_BRANCH_SELECTION_DESIGN
  );

  constructor(
    private authIdamService: AuthService,
    private translateService: TranslateService,
    protected authorizationService: AuthorizationService,
    protected activeFeaturesConfigcatService: ActiveFeaturesConfigcatService,
    protected applicationEventService: ApplicationEventService,
    protected idamRegisterTrackingService: IdamRegisterTrackingService,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) private platformId: Object,
    private configureCountryWiseFieldsService: ConfigureCountryWiseFieldsService,
    private countryBasedTierTwoConfigService: CountryBasedTierTwoConfigService,
    private passwordlessService: PasswordlessService,
    private hotJarEventsService: HotJarEventsService,
    private activeFeaturesConfigCatService: ActiveFeaturesConfigcatService,
    private companyDetailsFromIdService: CompanyDetailsFromIdService
  ) {
    super(authorizationService, activeFeaturesConfigcatService, applicationEventService);

    this.currentCountry = MarketDetectionUtil.getCountryCode();
    this.CURRENT_MARKET_LINKS = CURRENT_MARKET_LINKS();

    if (IS_SAVE_LEGAL_ADDRESS_AS_BILLING_AND_SHIPPING[this.currentCountry]) {
      this.hotJarEventsService.triggerHotJarEvent(HOTJAR_EVENT_LIST.saveLegalAddressAsShippingAndBilling);
    } else {
      this.hotJarEventsService.triggerHotJarEvent(HOTJAR_EVENT_LIST.originalVariantOnTierTwoSignup);
    }

    this.getFormConfig();
  }

  ngOnInit(): void {
    this.companyDetailsFromIdService.companyDetailsForTierTwo$
      .pipe(filter(Boolean))
      .subscribe((branch: IEntrepreneurInfoNetherlands | IEntrepreneurInfoFrance) => {
        this.branch = branch;
      });
  }

  removeUnderscore(branchNumber: string): string {
    return branchNumber.replace(/_/g, '');
  }

  handleSubmitEvent(event: IAdvancedFormEvent): void {
    const { saveLegalAddressAsShippingAndBilling } = event.payload.formData;

    const saveShippingAndBilling =
      saveLegalAddressAsShippingAndBilling && IS_SAVE_LEGAL_ADDRESS_AS_BILLING_AND_SHIPPING[this.currentCountry];

    if (saveShippingAndBilling) {
      this.saveLegalAddressAsShippingAndBillingTrackingEvent(saveLegalAddressAsShippingAndBilling);
    }

    let tier2Payload = this.configureCountryWiseFieldsService.createTierTwoPayload(event.payload.formData);

    if (this.currentCountry === CountryCode.Netherlands || this.currentCountry === CountryCode.France) {
      tier2Payload = {
        ...tier2Payload,
        businessName: this.branch?.businessName,
        legalAddressBuildingNumber: this.branch?.legalAddressBuildingNumber,
        legalAddressCity: this.branch?.legalAddressCity,
        legalAddressPostalCode: this.branch?.legalAddressPostalCode,
        legalAddressStreet: this.branch?.legalAddressStreet,
        [this.currentCountry === CountryCode.Netherlands && 'kvkNumber']: (this.branch as IEntrepreneurInfoNetherlands)
          ?.kvkNumber,
        [this.currentCountry === CountryCode.France && 'taxNumber']: (this.branch as IEntrepreneurInfoFrance)
          ?.taxNumber,
        externalLegalForm: this.branch?.externalLegalForm,
        externalBranch: this.branch?.externalBranch,
      };
    }

    const tier2Extras = { saveShippingAndBilling, saveLegalAddressAsShippingAndBilling };

    if (this.passwordlessService.isOnPasswordlessBusinessDetailsPage()) {
      this.passwordlessService.batchTier2SubmitPhase1(tier2Payload, tier2Extras);
    } else {
      this.handleBusinessDetailsSubmit(event, tier2Payload, tier2Extras);
    }
  }

  handleBusinessDetailsSubmit(
    event: IAdvancedFormEvent,
    tier2Payload: TierTwoRegistrationData,
    tier2Extras: { saveShippingAndBilling: boolean; saveLegalAddressAsShippingAndBilling: boolean }
  ): void {
    this.authIdamService
      .registerTierTwoAccount(tier2Payload, tier2Extras.saveShippingAndBilling, {
        saveLegalAddressAsShippingAndBilling: tier2Extras.saveLegalAddressAsShippingAndBilling,
      })
      .pipe(take(NUMBER_1))
      .subscribe(
        (data: AccountRegistrationSuccess) => {
          this.idamRegisterTrackingEvent();
          if (data.remarks) {
            this.handleVatIdValidationGaEvents(data.remarks);
          }
          if (isPlatformBrowser(this.platformId)) {
            ScrollUtils.scrollTop();
          }
          return event.done();
        },
        (error: CSSHttpError) => {
          ScrollUtils.scrollTop();
          if (isPlatformBrowser(this.platformId)) {
            ScrollUtils.scrollTop();
          }
          if (error.invalidParams) {
            this.handleValidationEventFromAPI(error);
          }

          return this.handleRegistrationFail(event, error);
        }
      );
  }

  handleVatIdValidationGaEvents(remarks: AccountRegistrationSuccess['remarks']) {
    const validationRemark = remarks.find(
      ({ remark }) => VAT_ID_VALIDATION_GA_EVENT_LABELS[remark.toLowerCase()] !== undefined
    );
    if (!validationRemark) {
      return;
    }
    this.idamRegisterTrackingService.vatIdValidationGaEventTracking(validationRemark.remark);
  }

  handleValidationEventFromAPI(error: CSSHttpError) {
    const errors = ErrorsUtil.collectFormAPIErrors(error);
    const message = ErrorsUtil.concatErrorsToString(errors);
    this.idamRegisterTrackingService.idamSignUpErrorEventTracking(message);
  }

  handleValidationEvent(event: IAdvancedFormEvent): void {
    ScrollUtils.scrollToFirstOfClass('mm-field--error');
    const errors = ErrorsUtil.collectFormErrors(event.payload);
    const message = ErrorsUtil.concatErrorsToString(errors);
    this.idamRegisterTrackingService.idamSignUpErrorEventTracking(message);
  }

  handleRegistrationFail(event: IAdvancedFormEvent, httpError): void {
    const error = httpError?.error?.error;
    const message = httpError?.error?.message;
    const { invalidParams } = httpError;
    return error === taxIDConflictError
      ? this.handleTaxConflictAlert(error, message, event)
      : this.handleInvalidVatNumber(invalidParams, event);
  }

  private getFormConfig() {
    combineLatest([
      this.countryBasedTierTwoConfigService.formConfig,
      this.countryBasedTierTwoConfigService.hasPrefilledCompanyData,
    ])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([formConfig, hasPrefilledCompanyData]) => {
        this.advancedFormConfig = formConfig;
        this.isFieldDisabled = hasPrefilledCompanyData;
      });
  }

  private handleInvalidVatNumber(invalidParams, event): void {
    let VatNumberNotValidAlert = '';
    let VatNumberNotValidTitleAlert = '';

    if (invalidParams?.vatNumber?.type === BusinessStatus.blocked) {
      // split payment
      VatNumberNotValidAlert = VatNumberErrors.VatNumberBlockedAlert;
      VatNumberNotValidTitleAlert = VatNumberErrors.VatNumberBlockedTitleAlert;
    } else {
      VatNumberNotValidAlert = VatNumberErrors.VatNumberNotValidAlert;
      VatNumberNotValidTitleAlert = VatNumberErrors.VatNumberNotValidTitleAlert;
    }

    this.translateService.get([VatNumberNotValidAlert, VatNumberNotValidTitleAlert]).subscribe((translations) => {
      event.done({
        null: {
          reason: translations[VatNumberNotValidAlert],
          title: translations[VatNumberNotValidTitleAlert],
        },
        ...invalidParams,
      });
    });
  }

  private handleTaxConflictAlert(error: string, message: string, event: IAdvancedFormEvent): void {
    if (COUNTRY_WITH_VAT_NUMBER_VALIDATION[this.currentCountry]) {
      error = 'VATNUMBERNOTUNIQUE';
    }

    const taxNumberNotUniqueAlert = `${AUTHORIZATION_NOTIFICATIONS.submitError}${error && error.toUpperCase()}`;
    const taxNumberNotUniqueError = `PAGES.AUTH.ADD_BUSINESS_DETAILS.ERROR.${error && error.toUpperCase()}`;
    this.translateService.get([taxNumberNotUniqueAlert, taxNumberNotUniqueError]).subscribe((translations) => {
      const invalidParams = {
        taxNumber: { reason: translations[taxNumberNotUniqueError] },
      };
      event.done({
        null: {
          reason: translations[taxNumberNotUniqueAlert],
        },
        ...invalidParams,
      });
    });

    const label = message === 'Conflict' ? `{ ${error} }` : `{ ${message} }`;
    this.idamRegisterTrackingService.idamSignUpErrorEventTracking(label);
  }

  private idamRegisterTrackingEvent(): void {
    // old tier 2 flow before passwordless
    this.idamRegisterTrackingService.idamSignUpEventTracking(this.isBusiness, true);
  }

  private saveLegalAddressAsShippingAndBillingTrackingEvent(
    isSaveLegalAddressAsShippingAndBillingEnabled: boolean
  ): void {
    this.idamRegisterTrackingService.saveLegalAddressAsShippingAndBillingEventTracking(
      isSaveLegalAddressAsShippingAndBillingEnabled
    );
  }
}
